import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=beb07318&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb07318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb07318')) {
      api.createRecord('beb07318', component.options)
    } else {
      api.reload('beb07318', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=beb07318&scoped=true", function () {
      api.rerender('beb07318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/Product.vue"
export default component.exports